enum SeatReservationStatus {
  BOOKED = 'booked',
  COMPLETED = 'completed',
  AVAILABLE = 'available',
  DISABLED = 'disabled',
  HOLD = 'hold',
}

export type AdminSeatStatus =
  | 'available'
  | 'hold'
  | 'revel booked'
  | 'organizer booked'
  | 'disabled';

interface SeatAPIModel {
  readonly id: string;
  readonly serial_no: string;
  readonly price: string;
  readonly pax: number;
  readonly features: string;
  readonly area: string;
  readonly status: SeatReservationStatus;
  readonly reservation_details: ReservationDetails;
}

interface ReservationDetails {
  readonly id: string;
  readonly reserved_by: string;
  readonly booked_by: string;
  readonly booked_for: string;
  readonly phone_number: string;
  readonly reservation_code: string;
  readonly medium: string;
  readonly remarks: string;
  readonly email: string;
}

export type { SeatAPIModel, ReservationDetails };
export { SeatReservationStatus };
